import React from 'react';
import { Box, Container, useTheme } from '@mui/material';
import Header from './Header';

interface PageLayoutProps {
  title: string;
  subtitle?: string;
  backAction?: () => void;
  backActionLabel?: string;
  headerActions?: React.ReactNode;
  children: React.ReactNode;
}

const PageLayout: React.FC<PageLayoutProps> = ({ title, children, backAction, backActionLabel, headerActions }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.background.paper,
        px: { xs: 1, md: 6 },
        py: { xs: 1, md: 6 },
      }}
    >
      <Header
        title={title}
        backAction={backAction}
        backActionLabel={backActionLabel}
        headerActions={headerActions}
      />
      {children}
    </Box>
  );
};

export default PageLayout; 